import { FC, useState, useEffect, Fragment } from 'react';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
import useToggle from 'hooks/useToggle';
// Types
import QuizTypes from 'types/QuizTypes';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { setEntryTime } from 'store/player/playerSlice';
import { selectQuiz } from 'store/quiz/quizSelectors';
// Components
import PoweredBy from 'components/PoweredBy';
import PreQuizQuestionDialog from 'dialogs/PreQuizQuestion.dialog';
// i18next
import { Trans, useTranslation } from 'react-i18next';
import { selectRegisterData } from 'store/auth/authSelectors';

let interval:any = null;
const intervalTime = 1500;

const CountdownPage:FC = () => {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();
  // State
  const quiz:IQuiz | null = useAppSelector(selectQuiz);
  const registerData = useAppSelector(selectRegisterData);

  const [preQuiz, setPreQuiz] = useState(!!quiz?.preQuizPages && !!quiz?.preQuizPages[0]?.questions?.length);
  
  const { open, toggle } = useToggle();
  const hadnlePreQuizDialog = () => {
    toggle();
    setPreQuiz(false);
  }

  const navigateTo = useNavigateTo()

  const [ countdown, setCountdown ] = useState(3);

  const handleClearInterval = () => {
    if ( interval ) clearInterval(interval);
  }

  useEffect(() => {
    if ( !quiz ) return;

    if (!!quiz.registrationPage && quiz.registrationPage.showPriorQuiz && !registerData) {
      navigateTo('register');
    }

    if (preQuiz && (quiz.preQuizPages && quiz.preQuizPages[0] && quiz.preQuizPages[0].questions.length) &&
          [QuizTypes.Scoring, QuizTypes.Prediction].includes(quiz.type)
        ){
      toggle();
      return;
    }

    if ( [QuizTypes.Personality, QuizTypes.Poll].includes(quiz.type) ){
      dispatch(setEntryTime(new Date().getTime()));
      navigateTo('question');
    } else {
      handleClearInterval();
  
      interval = setInterval(() => {
        setCountdown((prevState:number) => prevState - 1);
      }, intervalTime);
    }

    return () => {
      handleClearInterval();
    }
    // eslint-disable-next-line
  }, [preQuiz, registerData]);

  useEffect(() => {
    if ( countdown === 0 ){
      dispatch(setEntryTime(new Date().getTime()));
      handleClearInterval();
      navigateTo('question');
    };
    // eslint-disable-next-line
  }, [countdown]);

  if ( !quiz || [QuizTypes.Personality, QuizTypes.Poll].includes(quiz.type) ) return null;
  return (
    <Fragment>
      {open ? (
        <PreQuizQuestionDialog onClose={hadnlePreQuizDialog} />
      ) : null}

      <div className="flex-grow flex flex-col justify-around items-center p-4">
        <div className="flex flex-col items-center w-9/12 mx-auto mb-2  md:mb-4">
          {quiz.showBrandLogoOnCountDown && quiz.countDownLogoImage ? (
            <div className="mb-2 md:mb-4">
              <img className="h-14" src={quiz.countDownLogoImage} alt="QuizWizard" />
            </div>
          ) : null}
          <p className="text-countdown text-center font-bold">{t('quiz.countdownPage.fasterYouScoreMorePointsYouGet')}</p>
        </div>
        {quiz.countDownImage ? (
          <div className="mb-2 md:mb-4 -mx-4">
            <img
              className="max-w-full block h-auto"
              src={quiz.countDownImage}
              alt=""
            />
          </div>
        ) : null}
        <div className="flex flex-col items-center w-9/12 mx-auto">
          <h3 className="text-countdown text-4xl font-bold mb-1 md:mb-8 text-center">
            <Trans t={t} components={{ br: <br /> }} i18nKey="quiz.countdownPage.goodLuck" />
          </h3>
          {quiz.socialShareEnabled ? (
            <p className="text-countdown text-center font-bold mb-2 md:mb-8">{t('quiz.countdownPage.shareSocialToEarnBonusPoints')}</p>
          ) : null}
          <div
            className="
              relative
              flex items-center justify-center
              w-32 h-32
              shadow-neu-content
              rounded-full
              mx-auto
            "
          ><span className="text-countdown text-7xl font-bold">{countdown}</span></div>
        </div>
        <div>
          {!quiz.whiteLabeling && <PoweredBy />}
        </div>
      </div>
    </Fragment>
  )
}

export default CountdownPage;
